import React, {useEffect} from 'react';
import { Container, Typography, Button, Grid, Paper } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { motion } from 'framer-motion';
import { buttonColor, buttonHoverColor, primaryColor } from '../../UtilColorPalate/UtilColorPalate';
import { useNavigate } from 'react-router-dom'

const PaymentFailedPage = () => {
    const navigate = useNavigate();

       useEffect(() => {
              window.scrollTo(0, 0); // Scroll to top on mount
            }, []);
  return (
    <Container maxWidth="md" sx={{ textAlign: 'center', marginTop:"2%" }}>
      {/* <Paper
        elevation={3}
        sx={{ padding: '40px', borderRadius: '12px', backgroundColor: '#fff' }}
      > */}
        <Grid container direction="column" alignItems="center" spacing={4}>
          {/* Error Icon Animation */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
            >
              <ErrorIcon color="error" sx={{ fontSize: '120px' }} />
            </motion.div>
          </Grid>

          {/* Payment Failed Heading */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3, ease: 'easeOut' }}
            >
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
                Payment Failed!
              </Typography>
            </motion.div>
          </Grid>

          {/* Payment Failure Message */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5, ease: 'easeOut' }}
            >
              <Typography
                variant="h6"
                color="textSecondary"
                textAlign={"left"}
                sx={{ maxWidth: '500px', margin: '0 auto' }}
              >
                Unfortunately, your payment could not be processed. Please try again later or
                contact support if the issue persists.
              </Typography>
            </motion.div>
          </Grid>

          {/* Retry Button */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.7, ease: 'easeOut' }}
            >
              <Button
                variant="contained"
                color="primary"
                sx={{
                                                                                      color: "#fff",
                                                                                      textTransform: "none",
                                                                                      padding: "5px 15px",
                                                                                      borderRadius: "4px",
                                                                                      "&:hover": { backgroundColor: buttonHoverColor },
                                                                                    }}
                onClick={() => navigate('/cart')}
              >
                Retry Payment
              </Button>
            </motion.div>
          </Grid>

          {/* Back to Home Button */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.8, ease: 'easeOut' }}
            >
              <Button
                variant="outlined"
                color={primaryColor}
                sx={{
                    backgroundColor: buttonColor,
                    color: "#fff",
                    textTransform: "none",
                    padding: "5px 15px",
                    borderRadius: "4px",
                    "&:hover": { backgroundColor: buttonHoverColor },
                  }}
                onClick={() => window.location.href = '/'}
              >
                Back to Home
              </Button>
            </motion.div>
          </Grid>
        </Grid>
      {/* </Paper> */}
    </Container>
  );
};

export default PaymentFailedPage;